var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.conStype),attrs:{"id":`cnzz_stat_icon_${_vm.cid}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }